import { render, staticRenderFns } from "./Novel_Details.vue?vue&type=template&id=b208e8f6&scoped=true"
import script from "./Novel_Details.vue?vue&type=script&lang=js"
export * from "./Novel_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b208e8f6",
  null
  
)

export default component.exports